export default __webpack_public_path__ + "static/media/blogcard8.56f407da.png";